// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__UEBr1","anchor":"Logo_anchor__fh05h","logo_social":"Logo_logo_social__oRnj6","ranger":"Logo_ranger__BzKzj","a":"Logo_a__CWcNO"};